import { render } from "./individual-incorporation-detail.vue?vue&type=template&id=0a10d76a"
import script from "./individual-incorporation-detail.vue?vue&type=script&lang=js"
export * from "./individual-incorporation-detail.vue?vue&type=script&lang=js"

import "./individual-incorporation-detail.vue?vue&type=style&index=0&id=0a10d76a&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__